.sku {
    margin-bottom: var(--spacer-4);
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.name {
    margin-bottom: var(--spacer-16);
    font: var(--font-h-24);
}

.price {
    font: var(--font-p-16);
}
